var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5C0 2.23858 2.23858 0 5 0H19C21.7614 0 24 2.23858 24 5V19C24 21.7614 21.7614 24 19 24H5C2.23858 24 0 21.7614 0 19V5Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0003 17.7498C13.9018 17.7503 13.8041 17.7311 13.7131 17.6933C13.6221 17.6555 13.5396 17.6 13.4703 17.5298L8.47032 12.5298C8.32987 12.3892 8.25098 12.1986 8.25098 11.9998C8.25098 11.8011 8.32987 11.6105 8.47032 11.4698L13.4703 6.46985C13.6125 6.33737 13.8005 6.26524 13.9948 6.26867C14.1891 6.2721 14.3745 6.35081 14.5119 6.48822C14.6494 6.62564 14.7281 6.81102 14.7315 7.00532C14.7349 7.19963 14.6628 7.38767 14.5303 7.52985L10.0603 11.9998L14.5303 16.4698C14.6708 16.6105 14.7497 16.8011 14.7497 16.9998C14.7497 17.1986 14.6708 17.3892 14.5303 17.5298C14.4611 17.6 14.3785 17.6555 14.2875 17.6933C14.1965 17.7311 14.0989 17.7503 14.0003 17.7498Z",
    fill: "#0A0A0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.ebaa847ddad1aaff9d6117dd3059ea95.svg";
export { ForwardRef as ReactComponent };